import { Box, Flex, Divider, Grid } from '@chakra-ui/react'
import { useState } from 'react'

import TabbedDisplay from 'modules/TabbedDisplay'

import { TableauEmbed } from 'components'
import { registerTableauPage } from 'components/Embed/tableauSearchIndex'

import { BioriskPages } from 'config/apps/Biorisk/Custom/Biorisk/BioriskPages'
import { getMediaDefaultWidget } from 'config/common/baseModel/Media'
import { getPressReleasesDefaultWidget } from 'config/common/baseModel/PressReleases'

import AlertsSection from './Alerts'
import ReportSection from './ReportSection'

registerTableauPage({
  app: 'biorisk',
  path: '',
  tableauPath: '/Biorisk_Platform_NEW/Frontpage',
})
const TableauSection = () => {
  return (
    <Box>
      <TableauEmbed path={`/Biorisk_Platform_NEW/Frontpage`} height={'120vh'} />
    </Box>
  )
}

const PandemicDashboard = () => {
  const [showMore, setShowMore] = useState(false)
  const [rowHeight, setRowHeight] = useState('500px')

  return (
    <Flex flexDir='column' p='1rem' mt='0rem'>
      <Grid gridTemplateColumns={'2fr 2fr'}>
        <AlertsSection />
        <ReportSection
          showMore={showMore}
          handleShowMore={() => setShowMore(!showMore)}
          heightCB={(h: string) => setRowHeight(h)}
        />
      </Grid>

      <Divider my={4} />

      <TabbedDisplay
        variant='line'
        tabListWrapper={null}
        tabs={[
          {
            heading: 'Outbreak Tracker',
            body: <TableauSection />,
          },
          {
            heading: 'Media',
            body: getMediaDefaultWidget({
              title: 'Media',
              view: BioriskPages['VariantsMedia'].views[0],
            }).body,
          },
          {
            heading: 'Press Releases',
            body: getPressReleasesDefaultWidget({
              view: BioriskPages['VariantsPressReleases'].views[0],
            }).body,
          },
        ]}
      />
    </Flex>
  )
}

export default PandemicDashboard
